import { AdminTinglysingPage } from "@/components/AdminTinglysingPage/AdminTinglysingPage";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/superuser/tinglysing/")({
  head: () => ({
    meta: [{ title: "Superuser tinglysing | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <DocumentTitle>Admin tinglysing</DocumentTitle>

      <AdminTinglysingPage />
    </>
  );
}
